<template>
  <div class="page_main">
    <div class="search_block">
      <Form :label-width="85" inline>
        <!-- <FormItem label="就诊类别">
          <Select v-model="table.search.PatientType" clearable>
            <Option v-for="item in patientTypeList" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem> -->
        <FormItem label="检查类型">
          <Select v-model="table.search.ExamTypeName" clearable>
            <Option v-for="item in examTypeNameList" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem>
        <FormItem label="时间" :label-width="60">
          <Date-picker v-model="timeValue" :options="dateOptions" style="width:200px" format="yyyy-MM-dd"
            type="daterange" placement="bottom-end" placeholder="请选择时间" :clearable="false"
            @on-change="(val) => { table.search.BeginTime = val[0]; table.search.EndTime = val[1] }"></Date-picker>
        </FormItem>
      </Form>
      <div>
        <Button class="mr-3" @click="resetHandle">重置</Button>
        <Button class="mr-3" type="success" @click="search">查询</Button>
      </div>
    </div>
    <div class="fx-row">
      <div class="block-lf fx-col">
        <Input v-model="organName" class="lf-search" placeholder="请输入医院名称" clearable @on-enter="getHospital"></Input>
        <div class="hos-list fx-1">
          <div v-for="item in hospitalList" :key="item.organID" :class="{ 'hos-active': item.status == 1 }" class="hos-list-item" @click="selHosItem(item)">
            <div>{{item.organName}}</div>
            <Icon v-show="item.status == 1" type="md-checkmark" />
            <i v-show="item.status != 1" class="icon-place"></i>
          </div>
        </div>
      </div>
      <div class="block-rig fx-1">
        <div class="btn-group fx-row-cen">
          <div :class="{ 'btn-group-active': btnGroupActive == 0 }" @click="btnGroupActiveHandle(0)">影像量统计</div>
          <div :class="{ 'btn-group-active': btnGroupActive == 1 }" @click="btnGroupActiveHandle(1)">磁盘量统计</div>
        </div>
        <div class="fx-cen" v-show="btnGroupActive == 0">
          <div class="w100"></div>
          <div class="tc fx-1">
            <p class="rig-title">
              <span>{{ table.search.BeginTime ? table.search.BeginTime + '至' + table.search.EndTime : '' }}</span> 影像量统计
              <span></span>{{ examineCount }}(人次)</p>
            <p class="rig-title-sm">
              【统计条件】检查时间：{{ table.search.BeginTime ? table.search.BeginTime + '至' + table.search.EndTime : '全部' }}，机构名称：{{ organNameList.length == 0 ? '无' : organNameList.toString() }}，检查类型：{{ table.search.ExamTypeName ? table.search.ExamTypeName : '全部' }}
            </p>
            <!-- ，检查类型：{{table.search.ExamTypeName?table.search.ExamTypeName:'全部'}} -->
          </div>
          <div class="tr w100"><Button class="mr-3" @click="exportHandle">导出</Button></div>
        </div>
        <div class="fx-row" v-show="btnGroupActive == 0">
          <DataTable class="table-width" ref="dataTable" tableDataName="obj" :pageShow="false" :columns="table.columns"
            :apiUrl="table.apiUrl" :search="table.search" requestType="post" @getData="getTableData"></DataTable>
          <div class="rig-chart mr-3">
            <div ref="myEchart" class="mb-16"></div>
            <div ref="myEchart2"></div>
          </div>
        </div>
        <div class="fx-cen" v-show="btnGroupActive == 1">
          <div class="w100"></div>
          <div class="tc fx-1">
            <p class="rig-title">
              <!-- <span>{{ table.search.BeginTime ? table.search.BeginTime + '至' + table.search.EndTime : '' }}</span>  -->
              磁盘使用量
              {{userSize}}GB/{{totalSize}}GB</p>
            <!-- <p class="rig-title-sm">
              【统计条件】检查时间：{{ table.search.BeginTime ? table.search.BeginTime + '至' + table.search.EndTime : '全部' }}，机构名称：{{ organNameList.length == 0 ? '无' : organNameList.toString() }}，检查类型：{{ table.search.ExamTypeName ? table.search.ExamTypeName : '全部' }}
            </p> -->
            <!-- ，检查类型：{{table.search.ExamTypeName?table.search.ExamTypeName:'全部'}} -->
          </div>
          <!-- <div class="tr w100"><Button class="mr-3">导出</Button></div> -->
        </div>
        <div v-show="btnGroupActive == 1" class="chart-group fx-row-cen">
          <div class="fx-1" ref="echartWidth">
            <div class="echartTit">就诊类别磁盘量分布图（单位：GB）</div>
            <div class="myEchart" :style="{ width: echartWitch + 'px' }" ref="myEchart3"></div>
          </div>
          <!-- <div class="fx-1""> -->
          <!-- <div class="echartTit">就诊类别磁盘量分布图（单位：GB）</div>
            <div class="myEchart" :style="{width:echartWitch+'px'}" ref="myEchart4"></div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import echarts from 'echarts'
import dayjs from 'dayjs'
export default {
  components: {
    DataTable
  },
  data() {
    const toDay = dayjs().format('YYYY-MM-DD')
    return {
      btnGroupActive: 0,
      activeIndex: [],
      checkTypeList: [],
      typeList: [],
      myChart: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      organName: '',
      table: {
        columns: [
          {
            title: "序号",
            type: "index",
            align: 'center',
            width: "60",
          },
          {
            title: '医院名称',
            align: 'center',
            key: 'name',
          },
          {
            title: '检查总量',
            align: 'center',
            key: 'count',
          },
          {
            title: '检查类型',
            align: 'center',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              },
                [
                  h('ul', params.row.orderInfo.map(item => {
                    return h('li', {
                    }, item.examTypeName)
                  }))
                ])
            }
          },
          // {
          //   title: '就诊类别',
          //   align: 'center',
          //   key: 'list',
          // },
          {
            title: '检查量',
            align: 'center',
            render: (h, params) => {
              return h('div', {
                attrs: {
                  class: 'subCol'
                }
              },
                [
                  h('ul', params.row.orderInfo.map(item => {
                    return h('li', {
                    }, item.count)
                  }))
                ])
            }
          },
        ],
        apiUrl: 'HomePage/GetImageStatistics',
        search: {
          ExamOrganCode: [],
          ExamTypeName: '',
          PatientType: '',
          BeginTime: toDay,
          EndTime: toDay
        }
      },
      hospitalList: [],
      tableData: [],
      // patientTypeList: [],
      examTypeNameList: [],
      organNameList: [],
      examineCount: 0,
      echartTypeList: [],
      echartValList: [],
      timeValue: [toDay, toDay],
      echartWitch: 0,
      ecTypeList: [],
      ecCountList: [],
      dateOptions: {
        shortcuts: [
          {
            text: '最近三天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              return [start, end];
            }
          },
          {
            text: '最近一周',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            }
          },
          {
            text: '最近一个月',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            }
          },
          {
            text: '最近三个月',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            }
          }
        ]
      },
      totalSize:0,
      userSize:0
    }
  },
  watch: {
    btnGroupActive(newVal, oldVal) {
      this.$nextTick(() => {
        this.echartWitch = this.$refs.echartWidth.clientWidth
        this.$nextTick(() => { if (newVal) this.initEcharts3() })
      })
    }
  },
  mounted() {
    // this.initEcharts2()
    // this.initEcharts3()
    this.getHospital()
    // this.getPatientTypeList()
    this.getDiskStat()
    // let echartTimeID = null
    // window.addEventListener("resize", () => {
    //   clearTimeout(echartTimeID)
    //   echartTimeID = setTimeout(() => {
    //     this.echartWitch=this.$refs.echartWidth.clientWidth
    //     console.log(this.echartWitch)
    //     this.initEcharts3()
    //     // this.$refs.myEchart3.resize()
    //   }, 500)
    // });
  },
  created() {
    this.getExamTypeNameList()
    this.getDiskUseAndFree()
  },
  methods: {
    search: function () {
      const list = this.hospitalList.filter(item => item.status == 1)
      this.table.search.ExamOrganCode = list.map(item => item.organCode)
      if (this.table.search.ExamOrganCode.length == 0) {
        this.$Message.warning('请选择医院！')
        return
      }
      this.organNameList = list.map(item => item.organName)
      this.$refs.dataTable.initload();
    },
    btnGroupActiveHandle(status){
      this.btnGroupActive = status
      if(status==0){
        this.$nextTick(()=>{
          this.$refs.dataTable.initload();
        })
      }else{
        this.getDiskStat()
      }
    },
    getDiskUseAndFree(){
      this.$api.get('/HomePage/DiskUseAndFree').then((rsp) => {
        if (rsp != false) {
          console.log(rsp)
          let userSize=0
          let totalSize=0
          // linux系统数据
          if(rsp.data.some(item=>item.totalSize)){
            console.log(111)
            rsp.data.forEach(item=>{
              userSize+=Number(item.userSize)*1000
              totalSize+=Number(item.totalSize)*1000
            })
          // windows系统数据
          }else if(rsp.data.some(item=>item.totalSpace)){
            rsp.data.forEach(item=>{
              userSize+=Number(item.usedSpace?item.usedSpace:0)*1000
              totalSize+=Number(item.totalSpace?item.totalSpace:0)*1000
            })
          }
          this.userSize=userSize/1000
          this.totalSize=totalSize/1000
        }
      })
    },
    getDiskStat() {
      this.$api.get('/HomePage/GetImageExamOrganCodeStatistics').then((rsp) => {
        if (rsp != false) {
          console.log(rsp)
          if(rsp.data.data){
            let ecTypeList = []
            let ecCountList = []
            rsp.data.data.forEach(item => {
              ecTypeList.push(item.type)
              ecCountList.push(Number(item.sumCoun).toFixed(2))
            })
            this.ecTypeList = ecTypeList
            this.ecCountList = ecCountList
          }
        }
      });
    },
    getTableData(val) {
      if (val) {
        this.examineCount = val.obj.reduce((prev, next) => prev + next.count, 0)
        // if(val.obj.length!=0){
        //   this.echartTypeList=val.obj[0].orderInfo.map(item=>item.examTypeName)
        //   let list=this.echartTypeList.map(item=>{
        //     return {
        //       value: 0,
        //       name: item
        //     }
        //   })
        //   val.obj.forEach(item=>{
        //     this.echartTypeList.forEach((sonItem,sonIndex)=>{
        //       list[sonIndex].value=list[sonIndex].value+item.orderInfo[sonIndex].count
        //     })
        //   })
        //   this.echartValList=list
        //   this.initEcharts1()
        //   console.log(list)
        // }
        if (val.dictionary) {
          this.echartTypeList = Object.keys(val.dictionary)
          console.log(this.echartTypeList)
          this.echartValList = this.echartTypeList.map(item => {
            return {
              name: item,
              value: val.dictionary[item]
            }
          })
        }
        this.initEcharts1()
      } else {
        this.examineCount = 0
        this.echartTypeList = this.examTypeNameList
        this.echartValList = this.examTypeNameList.map(item => {
          return {
            name: item,
            value: 0
          }
        })
        this.initEcharts1()
      }
    },
    getHospital() {
      this.$api.get('/HomePage/GetOrganinfoList', {
        organName: this.organName
      }).then((rsp) => {
        if (rsp != false) {
          this.hospitalList = rsp.data.map(item => {
            return {
              ...item,
              status: 0
            }
          })
        }
      });
    },
    exportHandle() {
      const list = this.hospitalList.filter(item => item.status == 1)
      this.table.search.ExamOrganCode = list.map(item => item.organCode)
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + "/HomePage/ImageQuantityExport?" + params;
      window.open(url);
    },
    // getPatientTypeList(){
    //   this.$api.get('/HomePage/GetPatientTypeList').then((rsp) => {
    //     if (rsp != false) {
    //       this.patientTypeList=rsp.data
    //     }
    //   });
    // },
    getExamTypeNameList() {
      this.$api.get('/HomePage/GetExamTypeNameList').then((rsp) => {
        if (rsp != false) {
          this.examTypeNameList = rsp.data
          this.echartTypeList = rsp.data
          this.echartValList = rsp.data.map(item => {
            return {
              name: item,
              value: 0
            }
          })
          this.initEcharts1()
        }
      });
    },
    initEcharts1() {
      this.myChart = echarts.init(this.$refs.myEchart)
      let option = {
        backgroundColor: '#F2F3F5',
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          top: "32%",
          right: "10px",
          // itemGap: 50,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#333",
            fontSize: 10
          },
          data: this.echartTypeList,
        },
        title: [
          {
            text: this.examineCount,
            subtext: '总检查量',
            textAlign: "center",
            x: '38%',
            y: '50%',
            textStyle: {
              fontSize: 27,
              fontWeight: 'normal',
              color: '#333333',
            },
            subtextStyle: {
              fontSize: 12,
              fontWeight: 'normal',
              align: "center",
              color: '#999'
            },
          },
          {
            text: '检查类型分布',
            x: '24px',
            y: '24px',
            textStyle: {
              fontSize: 18,
              fontWeight: 'normal',
              color: '#333333',
            },
          }
        ],
        series: [{
          type: 'pie',
          radius: ['70', '50'],
          center: ['40%', '60%'],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: ['#8543E0', '#1890FF', '#36CBCB', '#2FC25B', '#FACC14', '#F04864'],
          itemStyle: {
            normal: {
              borderWidth: 5,
              borderColor: '#F2F3F5',
            }
          },
          data: this.echartValList
        }

        ]
      };
      this.myChart.setOption(option)
    },
    initEcharts2() {
      this.myChart2 = echarts.init(this.$refs.myEchart2)
      let option2 = {
        backgroundColor: '#F2F3F5',
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          top: "32%",
          right: "10px",
          // itemGap: 50,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#333",
            fontSize: 10
          },
          data: ['门诊', '住院', '卒中', '急诊', '体检', '创伤'],
        },
        title: [
          {
            text: '14000',
            subtext: '总检查量',
            textAlign: "center",
            x: '38%',
            y: '50%',
            textStyle: {
              fontSize: 27,
              fontWeight: 'normal',
              color: '#333333',
            },
            subtextStyle: {
              fontSize: 12,
              fontWeight: 'normal',
              align: "center",
              color: '#999'
            },
          },
          {
            text: '就诊类别分布',
            x: '24px',
            y: '24px',
            textStyle: {
              fontSize: 18,
              fontWeight: 'normal',
              color: '#333333',
            },
          }
        ],
        series: [{
          type: 'pie',
          radius: ['70', '50'],
          center: ['40%', '60%'],
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          color: ['#8543E0', '#1890FF', '#36CBCB', '#2FC25B', '#FACC14', '#F04864'],
          itemStyle: {
            normal: {
              borderWidth: 5,
              borderColor: '#F2F3F5',
            }
          },
          data: [
            {
              value: 27,
              name: '门诊'
            },
            {
              value: 30,
              name: '住院'
            },
            {
              value: 24,
              name: '卒中'
            },
            {
              value: 27,
              name: '急诊'
            },
            {
              value: 27,
              name: '体检'
            },
            {
              value: 27,
              name: '创伤'
            }
          ],
        }

        ]
      };
      this.myChart2.setOption(option2)
    },
    initEcharts3() {
      this.myChart3 = echarts.init(this.$refs.myEchart3)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '10%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.ecTypeList,
            axisLine: {
              lineStyle: {
                color: '#F0F1F5',
              }
            },
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#F0F1F5'
              }
            },
            axisLabel: {
              textStyle: {
                color: '#999',
              },
              interval: 0
            }
          }
        ],
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                color: '#F0F1F5'
              }
            },
            axisTick: {
              lineStyle: {
                color: '#F0F1F5',
              }
            },
            axisLine: {
              lineStyle: {
                color: '#F0F1F5',
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#999',
              }
            },
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: '20px',
            data: this.ecCountList,
            label: {
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                      color: '#a8aab0',
                      fontStyle: 'normal',
                      fontSize: 12,   
                  },
                },
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0, 170, 173, 1)'
                }, {
                  offset: 1,
                  color: 'rgba(0, 170, 173, 0.32)'
                }]),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
              }
            }
          },

        ],
      };
      this.myChart3.setOption(option)
    },
    selHosItem(item) {
      item.status ? item.status = 0 : item.status = 1
    },
    resetHandle() {
      const toDay = dayjs().format('YYYY-MM-DD')
      this.timeValue = [toDay,toDay]
      this.table.search.ExamTypeName = ''
      this.table.search.PatientType = ''
      this.table.search.BeginTime = toDay
      this.table.search.EndTime = toDay
    }
  }
}
</script>
<style scoped lang="less">
/deep/.ivu-picker-panel-sidebar {
  width: 105px;
  margin-left: -105px
}

.table-width {
  width: calc(100vw - 725px);
}

.block-lf {
  width: 230px;
  background: #fff;
  padding: 12px;
  border-radius: 10px;
  height: calc(100vh - 3.5rem - 135px);

  .lf-search /deep/.ivu-input {
    background: #F2F3F5;
    border: none;
  }

  .hos-list {
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 10px;
    font-size: 16px;

    .hos-list-item {
      color: #666666;
      padding: 5px;
      margin-bottom: 5px;
      cursor: pointer;
      width: 195px;
      display: flex;
      flex-direction: row;
      align-items: center;
      div{
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .icon-place{
        width: 16px;
      }
    }

    .hos-active {
      background: rgba(45, 141, 240, 0.1);
      color: #2D8DF0;
    }
  }
}

.block-rig {
  background: #fff;
  margin-left: 10px;
  border-radius: 10px;

  // padding-bottom: 16px;
  .btn-group {
    font-size: 18px;
    color: #999999;
    margin-top: 24px;
    margin-left: 24px;

    >div {
      padding: 4px 15px;
      background: #F2F3F5;
      cursor: pointer;
    }

    .btn-group-active {
      background: #00AAAD;
      color: #fff;
    }
  }

  .rig-title {
    font-size: 20px;
    font-weight: 600;
    margin: 24px 0 6px;
    color: #000;

    span {
      color: #2D8DF0;
    }
  }

  .rig-title-sm {
    font-size: 14px;
    margin-bottom: 9px;
  }

  .chart-group {
    padding: 15px 24px;

    >div:first-child {
      margin-right: 24px;
      border: 1px solid #E5E5E5;
      display: flex;
      flex-direction: column;
    }

    >div {

      >.echartTit {
        background: #F2F3F5;
        border-bottom: 1px solid #E5E5E5;
        font-size: 16px;
        padding: 21px 24px;
      }

      .myEchart {
        width: 500px;
        height: 300px;
      }
    }
  }

  .w100 {
    width: 100px;
  }

  .rig-chart {
    margin-top: 15px;
    width: 240px;

    >div {
      width: 240px;
      height: 240px;
    }
  }
}
</style>